/**
 * @desc This page applies 508 Compliance standards on table element
 *
 * @prettier
 * @author Alexander Nagelberg
 * @author Victoria Saleem (minor updates)
 **/
import React from 'react'

import { formatUnixDateStringToDisplayString } from 'app/utils/dateTimeUtils'

const RefundHistory = ({ events }) => (
  <div id='lgy-funding-fee-refund-history'>
    <table aria-label='Refund History Table'>
      <caption>Refund History Table</caption>
      <thead>
        <tr>
          <th scope='col' id='date'>
            Date
          </th>
          <th scope='col' id='user'>
            User
          </th>
          <th scope='col' id='activity'>
            Activity
          </th>
        </tr>
      </thead>
      <tbody>
        {events?.map(event => (
          <tr key={event.id}>
            <td headers='date'>{formatUnixDateStringToDisplayString(event.date)}</td>
            <td headers='user'>{event.name}</td>
            <td headers='activity'>{event.activity}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default RefundHistory
